module.exports = __webpack_public_path__ + "img/欧文斯.1f0886d3.png";